//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import wx from 'weixin-js-sdk'; 
export default {
  name: 'douYinVerify',
  components: {
  },
  data () {
    return {
      // shortUrl:'https://v.douyin.com/i5x6JxaR/',
      shortUrl:'',
      code:'',
      name:'',
      phone:'',
      status:false,
      order:{goods:[]},
    }
  },
  created(){
     this.sign();
    //  this.getOrder();
    // setTimeout(()=>{
    //   this.scanQRCode();
    // },300) 
  },
  mounted(){
    // this.id = Number(this.$route.params.id);
    // this.changePop();
  
  },
  methods:{
    scanQRCode(){
      let that = this;
      wx.ready(()=> {
        wx.scanQRCode({
          needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
          scanType: ["qrCode","barCode"],
          success: function (res) {
            setTimeout(()=>{
                if(res.resultStr.indexOf(",") != -1){
                  that.shortUrl = that.$func.parseScanResult(res.resultStr);
                }else{
                  that.shortUrl = that.$func.parseScanResult(res.resultStr);
                }
                that.getOrder();
            },500);
          }
        })
      });
      wx.error((res)=> {
        console.log(res)
        // alert(res.errMsg);
      })
    },  
    getOrder(){
      let that = this;
      if(!this.code && !that.shortUrl){
        that.$func.showToast('请输入核销码或扫码');
        return ;
      }
      this.$func.startLoading();
      this.$api.getDouYinOrderNew({code:this.code,shortUrl:this.shortUrl}).then((res)=>{
        if(res){
          this.order = res.data;
          this.status = true;
          this.$func.endLoading();
            console.log(this.order);
        }
      })  
    },  
    sign(){
      let url = (window.location.href).split('#');
      if(url[0].indexOf('?') != '-1'){
        url = url[0].split('?');
      }
      this.$api.wxSign({url:url[0]}).then((res)=>{
        wx.config({
            debug: res.data.debug, // 开启调试模式,
            appId: res.data.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
            timestamp: res.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
            signature: res.data.signature,// 必填，签名，见附录1
            jsApiList: res.data.jsApiList || ['scanQRCode'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        });
      });
    },
    submit(){
      let that = this;
      if(this.order.goods.length <= 0){
        that.$func.showToast('请输入核销码或扫码');
        return false;
      }
      if(!this.name || !this.phone){
        that.$func.showToast('请输入用户姓名和电话');
        return false;
      }
      that.$func.confirm('确认核销？','提示',()=>{
        that.$func.startLoading();
        that.$api.douYinVerifyNew({goods:JSON.stringify(that.order.goods),name:that.name,phone:that.phone}).then((res)=>{
          if(res){
            that.$func.endLoading();
            setTimeout(()=>{
              that.code = '';
              that.shortUrl = '';
              that.name = '';
              that.phone = '';
              that.order = {goods:[]};
              that.status = false;
              that.$func.showToast('核销成功');
            },300)
          }
        })  
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/douYinVerify.vue